import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import PropTypes from 'prop-types';
import { showModal, createMarkup } from '../Helpers/FormHelper';

function handleOk(e, setModal, modalUrl) {
  if (modalUrl) {
    window.location = modalUrl;
  } else {
    showModal(e, setModal, false);
  }
}

export function ModalPopup({ message, title, setModal, modal, modalUrl }) {
  const titleStyle = {
    background: "#711C21",
    color: "white",
    padding: "10px"
  }

  const bodyStyle = {
    fontSize: 16
  }

  return (
    <div>
      <Modal isOpen={modal} className="test" backdrop="static" centered>
        <ModalHeader style={titleStyle}><span style={{ fontSize: 20 }}>{title}</span></ModalHeader>
        <ModalBody id="modalBody" style={bodyStyle} dangerouslySetInnerHTML={createMarkup(message)}>
        </ModalBody>
        <ModalFooter>
          <Button className={`btn blm-btn-primary`} onClick={e => handleOk(e, setModal, modalUrl)}>OK</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

ModalPopup.propTypes = {
  message: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  setModal: PropTypes.func.isRequired,
  modal: PropTypes.bool,
}
